"use client";
import { ReactNode, useState } from "react";

import { TourProvider } from "@reactour/tour";
import { MoveLeft, MoveRight } from "lucide-react";
import { Button } from "../components/ui/button";
import { steps } from "../lib/steps";

interface CustomTourProviderProps {
  children: ReactNode;
}
const CustomControls = ({
  currentStep,
  steps,
  setCurrentStep,
  setIsOpen,
}: any) => {
  const isLastStep = currentStep === steps.length - 1;

  return (
    <div className="flex justify-center mt-4">
      <Button
        size="sm"
        variant="secondary"
        className=" bg-green-500 hover:bg-green-600 text-xs z-[999] "
        onClick={() => {
          if (isLastStep) {
            setIsOpen(false);
          } else {
            setCurrentStep((s: number) => s + 1);
          }
        }}
      >
        {isLastStep ? "Exit" : "Next"}
        <MoveRight className="h-4 w-4 ml-2" />
      </Button>
    </div>
  );
};
export const CustomTourProvider = ({ children }: CustomTourProviderProps) => {
  const [isTourOpen, setIsTourOpen] = useState(true);
  const [currentStep, setCurrentStep] = useState(0);

  return (
    <TourProvider
      components={{ Navigation: CustomControls }}
      onClickMask={() => console.log("V")}
      startAt={currentStep}
      showDots={false}
      styles={{
        popover: (base) => ({
          ...base,
          zIndex: 99999,
          background: "#ffffff",
          color: "#1f2937",
          border: "1px solid #e5e7eb",
          borderRadius: "0.75rem",
          boxShadow:
            "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
          padding: "1.5rem",
          maxWidth: "24rem",
          pointerEvents: "all",
        }),
        clickArea: (base) => ({
          ...base,

          cursor: "not-allowed",
        }),
        maskArea: (base) => ({
          ...base,
          rx: 12,
          zIndex: 999,
          pointerEvents: "all",
          cursor: "grab",
        }),
        badge: (base) => ({
          ...base,
          display: "none",
        }),
        close: (base) => ({
          ...base,
          right: 8,
          top: 8,
          width: "0.8rem",
          height: "0.8rem",
          padding: 0,
        }),
        controls: (base) => ({
          ...base,
        }),
      }}
      scrollSmooth={true}
      showNavigation={true}
      steps={steps}
      // beforeClose={}
      afterOpen={() => {
        setCurrentStep(0);
        setIsTourOpen(true);
      }}
      // disableKeyboardNavigation={true}
      disableKeyboardNavigation={true}
    >
      {children}
    </TourProvider>
  );
};
